import { combineReducers } from "redux";
import jobReducer from "./job";
import filterReducer from "./filter";
import directionReducer from "./direction";
import mapReducer from "./map";
import settingsReducer from "./settings";

const reducers = combineReducers({
  jobReducer,
  filterReducer,
  directionReducer,
  mapReducer,
  settingsReducer,
});

export default reducers;
